import { Phone, Mail, MapPin, Star } from "lucide-react";
import { CONTACT } from "@/data/site";

const REVIEW_URL = process.env.REACT_APP_GOOGLE_REVIEW_URL;

export default function Footer() {
  return (
    <footer className="relative bg-[#050505] pt-24 pb-10 border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 pb-16">
          <div className="lg:col-span-2">
            <img src="/logo.png" alt="247 Aftermath Restoration Mgmt Inc" className="h-40 w-auto" />
            <a href={CONTACT.phoneHref} className="inline-flex items-center gap-3 mt-8 bg-gold text-black font-semibold px-8 py-4 hover:bg-gold-light transition-colors duration-300" data-testid="footer-call-btn">
              <Phone className="h-5 w-5" /> Emergency Line — {CONTACT.phone}
            </a>
            {REVIEW_URL && (
              <a href={REVIEW_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 mt-4 ml-0 sm:ml-4 border border-gold text-gold font-semibold px-8 py-4 hover:bg-gold hover:text-black transition-colors duration-300" data-testid="footer-review-btn">
                <Star className="h-5 w-5" /> Review Us on Google
              </a>
            )}
          </div>

          <div className="space-y-5">
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-gold">Reach Us</p>
            <a href={CONTACT.phoneHref} className="flex items-center gap-3 text-[#A3A3A3] hover:text-gold transition-colors" data-testid="footer-phone">
              <Phone className="h-4 w-4 text-gold" /> {CONTACT.phone}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-[#A3A3A3] hover:text-gold transition-colors" data-testid="footer-email">
              <Mail className="h-4 w-4 text-gold" /> {CONTACT.email}
            </a>
            <div className="flex items-start gap-3 text-[#A3A3A3]">
              <MapPin className="h-4 w-4 text-gold mt-1 shrink-0" /> {CONTACT.address}
            </div>
            <p className="text-[#A3A3A3] pt-2">Serving {CONTACT.area}</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-white/10">
          <p className="text-xs text-[#5a5a5a]">© {new Date().getFullYear()} 247 Aftermath Restoration Mgmt. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="/privacy" className="text-xs text-[#5a5a5a] hover:text-gold transition-colors" data-testid="footer-privacy-link">Privacy Policy</a>
            <a href="/terms" className="text-xs text-[#5a5a5a] hover:text-gold transition-colors" data-testid="footer-terms-link">Terms &amp; Conditions</a>
            <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#5a5a5a]">Available 24 / 7 / 365</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
